/**
 * Pre-Departure Checklist
 * Complete before every voyage
 *
 * IMPORTANT: WBC3 does NOT mandate a specific pre-departure checklist
 * for crewed workboats. This is a MINIMAL starting point.
 * Companies should customize to suit their vessel and operations.
 *
 * ALL ITEMS ARE EDITABLE - no locked items.
 */

export const PRE_DEPARTURE_CHECKLIST = {
  id: 'pre_departure',
  name: 'Pre-Departure',
  description: 'Minimal checks before every voyage - customize to suit your vessel',
  icon: 'Anchor',
  regulatory: 'WBC3 implied requirements',
  isCustomisable: true,
  items: [
    { id: 'pd_weather', text: 'Weather forecast assessed suitable for voyage', required: true },
    { id: 'pd_nav', text: 'Navigation equipment operational', required: true },
    { id: 'pd_steering', text: 'Steering tested', required: true },
    { id: 'pd_comms', text: 'Communications checked', required: true },
    { id: 'pd_crew', text: 'Crew briefed on voyage plan', required: true },
    { id: 'pd_lsa', text: 'Life-saving equipment ready for use', required: true }
  ]
};
